import React from "react";
import Settings from "../components/admin/Settings";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function SettingsPage() {

  return (
    <div>
      <TitleUpdater />
      <Settings />
    </div>
  );
}
